export const uuidParser = (uuid: string) => {
  return uuid.replace(/.*(\D0+)/g, '');
};

export const fuuidExp = /(f+-f+-f+-f+-0*[123456789]\d*)/g;
